<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-2 rounded-lg overflow-hidden">
          <v-toolbar flat color="primary" dark dense>
            <v-icon left>mdi-chart-areaspline</v-icon>
            <v-toolbar-title class="subtitle-1 font-weight-bold">Indicadores de Crises ({{ periodLabel }})</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="pt-4">
            <div class="mb-2 font-weight-bold grey--text text--darken-2">Média de Crises por Turno</div>
            <v-row dense>
              <v-col v-for="shift in shifts" :key="shift.key" cols="6" sm="3">
                <v-card outlined class="text-center pa-2 rounded-md transition-swing" hover>
                  <v-icon :color="shift.color" large>{{ shift.icon }}</v-icon>
                  <div class="text-caption grey--text">{{ shift.label }}</div>
                  <div class="text-h6 primary--text">{{ shift.average }}</div>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <div class="mb-2 font-weight-bold grey--text text--darken-2">Horários de Pico (Top 3)</div>
            <v-row dense>
              <v-col v-for="(peak, index) in peakHours" :key="index" cols="4">
                <v-card outlined class="text-center pa-2 rounded-md" :class="index === 0 ? 'border-highlight' : ''">
                  <v-icon color="amber darken-2">mdi-clock-alert-outline</v-icon>
                  <div class="text-h6 mb-0">{{ peak.hour }}h</div>
                  <div class="text-caption grey--text">{{ peak.total }} crises</div>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <div class="mb-2 font-weight-bold grey--text text--darken-2">Crises por Tipo ({{ periodLabel }})</div>
            <div v-if="types.length > 0">
              <v-chip
                v-for="type in types"
                :key="type.spasm_type__id"
                class="ma-1"
                color="secondary"
                label
                outlined
              >
                <span class="font-weight-bold mr-1">{{ type.total }}</span>
                {{ type.spasm_type__name || 'Sem Tipo' }}
              </v-chip>
            </div>
            <div v-else class="text-caption grey--text">
              Nenhum registro por tipo no período selecionado.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SpasmsIndicators',
  props: {
    days: {
      type: [Number, String],
      default: 7
    },
    periodMetrics: {
      type: Object,
      default: () => ({})
    },
    hourMetrics: {
      type: Object,
      default: () => ({})
    },
    typeMetrics: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    metricKey() {
      if (this.days === 'all' || this.days == 6) return 'last_4_months'
      const d = parseInt(this.days)
      if (d === 4) return 'last_4_months'
      return `last_${d}_days`
    },
    periodLabel() {
      if (this.days === 'all') return 'Todo o período'
      const d = parseInt(this.days)
      if (d === 4) return 'Últimos 4 meses'
      if (d === 6) return 'Últimos 6 meses'
      return `Últimos ${d} dias`
    },
    divisor() {
      if (this.days === 'all' || this.days == 6) return 120
      const d = parseInt(this.days)
      return d === 4 ? 120 : d
    },
    shifts() {
      const data = this.periodMetrics[this.metricKey] || {};
      const config = [
        { key: 'morning', label: 'Manhã', icon: 'mdi-weather-sunset-up', color: 'orange lighten-1' },
        { key: 'afternoon', label: 'Tarde', icon: 'mdi-weather-sunny', color: 'amber darken-1' },
        { key: 'night', label: 'Noite', icon: 'mdi-weather-night', color: 'indigo darken-1' },
        { key: 'midnight', label: 'Madrugada', icon: 'mdi-weather-night-partly-cloudy', color: 'blue-grey darken-3' },
      ];

      return config.map(c => ({
        ...c,
        average: ((data[c.key] || 0) / this.divisor).toFixed(2).replace('.', ',')
      }));
    },
    peakHours() {
      const data = this.hourMetrics[this.metricKey] || {};
      const hours = Object.keys(data).map(hour => ({
        hour: hour.padStart(2, '0'),
        total: data[hour]
      }));

      // Sort by total descending and take top 3
      return hours.sort((a, b) => b.total - a.total).slice(0, 3);
    },
    types() {
      return this.typeMetrics[this.metricKey] || [];
    }
  }
}
</script>

<style scoped>
.rounded-md {
  border-radius: 12px;
}
.border-highlight {
  border: 1.5px solid var(--v-primary-base) !important;
}
</style>
